import { Row, Col, Container } from "react-bootstrap";
import { FacebookFilled, InstagramFilled, TwitterSquareFilled } from "@ant-design/icons";
import './Footer.css'

const Footer = ()=> {
    return (
        <div className="site-footer">
            <Container>
                <Row>
                    <Col xs={6}>
                        <Row className="footertitle pb-3" >About US</Row>
                        <Row className="text-justify "> H2O is Houston's #1 place to shop for your new vehicle. We have 10 years experience in helping our customers succesfully find their new vehicle.
                        Let us show you the difference with our service.</Row>
                        <Row className="text-justify ">&nbsp;</Row>
                        <Row className="text-justify"><a href="tel:111-222-1234">Phone: 111-222-1234</a></Row>
                        <Row className="text-justify "><a href="mailto: h2ohoustontx@gmail.com">Email: h2ohoustontx@gmail.com</a></Row>
                        <Row className="text-justify ">&nbsp;</Row>
                    </Col>
        
                    <Col xs={3}>

                    </Col>
        
                    <Col xs={3}>
                        <Row className="footertitle pb-3">Our Hours</Row>
                        <Row>
                            <Col xs={12} >
                                <Row>
                                    <Col className="facebookIco">Monday</Col>
                                    <Col className="facebookIco">8AM - 7PM</Col>
                                </Row>
                            </Col>
                            <Col xs={12}>
                                <Row>
                                    <Col className="facebookIco">Tuesday</Col>
                                    <Col className="facebookIco">8AM - 7PM</Col>
                                </Row>
                            </Col>
                            <Col xs={12}>
                                <Row>
                                    <Col className="facebookIco">Wednesday</Col>
                                    <Col className="facebookIco">8AM - 7PM</Col>
                                </Row>
                            </Col>
                            <Col xs={12}>
                                <Row>
                                    <Col className="facebookIco">Thursday</Col>
                                    <Col className="facebookIco">8AM - 7PM</Col>
                                </Row>
                            </Col>
                            <Col xs={12}>
                                <Row>
                                    <Col className="facebookIco">Friday</Col>
                                    <Col className="facebookIco">8AM - 7PM</Col>
                                </Row>
                            </Col>
                            <Col xs={12}>
                                <Row>
                                    <Col className="facebookIco">Saturday</Col>
                                    <Col className="facebookIco">8AM - 7PM</Col>
                                </Row>
                            </Col>
                            <Col xs={12}>
                                <Row>
                                    <Col className="facebookIco">Sunday</Col>
                                    <Col className="facebookIco">Close</Col>
                                </Row>
                            </Col>
                        </Row>

                    </Col>
                </Row>
            </Container>
            <Container className=" border-bottom pb-3 mb-3 just d-flex justify-content-left">
                <FacebookFilled className="mx-2 facebookIco" style={{fontSize:'24px'}}/>
                <InstagramFilled className="mx-2 instagramIco" style={{fontSize:'24px'}}/>
                <TwitterSquareFilled className="mx-2 twitterIco" style={{fontSize:'24px'}}/>
            </Container>
        </div>
    )
}
export default Footer;